// extracted by mini-css-extract-plugin
module.exports = {"Back":"Background_Back__1UJ6A","fadein":"Background_fadein__1_uHv","BackChange":"Background_BackChange__sM1-U"};